import React, { useState, useEffect } from 'react'
import { message } from 'antd'
import util from 'meinian-package/src/utils/util'
import moment from 'moment'
import Modal from 'meinian-package/src/component/modal'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import { isGlobalAuthVersion, sampleHasAuth, teamHasAuth } from 'meinian-package/src/utils/auth'
import GCollect from 'meinian-package/src/component/collect'
import Input from 'meinian-package/src/baseComponent/input'
import noPermissionPrompt from 'meinian-package/src/component/useFunModal/noPermissionPrompt'
import versionNumber from 'meinian-package/src/component/useFunModal/versionNumber'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import request from 'meinian-package/src/utils/request'
import Button from 'meinian-package/src/baseComponent/button'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import MoveImage from 'meinian-package/src/component/useFunModal/moveImage'
import { getBatchSelected, getBatchSelectedInfo, answer } from './base'
import DownloadCenter from '../download'
import moreFolderModalFun from '../../publicComponent/useFunModal/moveFolder'
import { renderDownloadModal } from './download'
import './index.less'

export const Collect = (props) => {
  const { onChange, green, style } = props
  const [size, setSize] = useState(0)
  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])

  return <GCollect
    currentBlog={getBatchSelectedInfo().get([...getBatchSelected()][0])}
    idList={[...getBatchSelectedInfo()].map(m => ({
      blogId: m[1].imageGroupEntityId,
      platformId: m[1].platformId,
      collectId: m[1].collectId,
      inspirationId: m[1].inspirationId
    }))}
    hasCurInstated
    afterJoin={onChange}
    beforeCollect={() => {
      if (size < 1) { return false }
    }}
  >
    <Button type={`${!green ? 'normal' : 'primary'}`} style={style} disabled={size < 1}>采集</Button>
  </GCollect>
}
export const CreateSample = (props) => { // 没有用到
  const { style, onChange } = props
  const [size, setSize] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  const onClickButton = async () => {
    const addSampleInfoList = [...getBatchSelectedInfo()].map(_style => ({
      inspirationId:
        _style[1].inspirationId,
      blogId: _style[1].imageGroupEntityId,
      platformId: _style[1].platformId,
      collectId: _style[1].collectId
    }))
    try {
      setLoading(true)
      const res = await request.spost('/zhikuan/mn/sample/upgrade-sample-info', addSampleInfoList)
      const { successList, failList } = res
      setLoading(false)
      Modal.info({
        title: '样衣生成提示',
        children: successList.length > 0 ? (failList.length > 0 ? `已成功生成样衣${successList.map(sample => <span>{sample.name}&nbsp;</span>)}，生成样衣失败${failList.map(sample => <span>{sample.name}&nbsp;</span>)}，请前往样衣管理查看` : '样衣已生成，请前往样衣管理查看') : '样衣生成失败，请重试或联系客服反馈'
      })
    } catch (err) {
      console.error(err)
    }
    onChange && onChange()
  }
  return (<div>
    <Button type="normal" style={{ marginRight: 16, ...style }} onClick={onClickButton} disabled={size < 1}>生成样衣</Button>
    <Modal
      title={<span style={{ color: 'var(--m-text-1)' }}>样衣生成提示</span>}
      visible={loading}
      onCancel={() => setLoading(false)}
      hiddenFooter
    >
      样衣生成中
    </Modal>
  </div>
  )
}
export const Delete = (props) => {
  const { onChange, green } = props
  const [size, setSize] = useState(0)
  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  const onDelete = async () => {
    ModalConfirm.show({
      title: '确认删除款式？',
      content: '当款式被删除后，在回收站保留30天，超过30天将无法恢复。',
      onOk: async () => {
        try {
          await request.post('/zhikuan/ins/inspiration/batch-remove-from-inspiration', {
            blogs: [...getBatchSelectedInfo()].map(m => ({ blogId: m[1].imageGroupEntityId, fromInspirationId: m[1].inspirationId })),
          })
          onChange && onChange()
        } catch (err) {
          console.error('/zhikuan/ins/inspiration/remove-from-inspiration', err)
        }
      },
    })
    request.track({ code: 6400014, type: '批量移除' })
  }
  return <Button type={`${!green ? 'normal' : 'primary'}`} style={{ marginRight: 16 }} onClick={onDelete} disabled={size < 1}>删除</Button>
}

export const DeleteItem = (props) => { // 单纯的删除
  const { onChange } = props
  const [size, setSize] = useState(0)
  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  const onDelete = async () => {
    const selectData = getBatchSelected()
    onChange && onChange(selectData)
  }
  return <Button type="normal" style={{ marginRight: 16 }} onClick={onDelete} disabled={size < 1}>删除</Button>
}

const Download = (props) => { // 批量下载 样衣暂无批量下载
  const { style, fileName, onChange, green, hiddenFolderLevel } = props
  const [size, setSize] = useState(0)

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])

  const download = () => {
    if (isGlobalAuthVersion(150001) && Array.from(getBatchSelected()).length > 50) {
      versionNumber({
        title: '款式单次批量下载'
      })
      return
    }
    renderDownloadModal({
      hiddenFolderLevel,
      onOk: async (type, keepStruct) => {
        await request.post('/zhikuan/mn/export/download-image-task', {
          collectIdList: [...getBatchSelectedInfo()].map(m => m[1].collectId),
          fileName,
          type,
          keepStruct
        })
        util.track('mn-image-download', {
          module1: '批量下载',
          module2: type === 1 ? '全部图片' : '首图',
        })
        DownloadCenter.start({ type: 1 })
        onChange && onChange()
      }
    })
    request.track({ code: 6400012, type: `批量下载-${[...getBatchSelected()]}` })
  }
  return <Button type={`${!green ? 'normal' : 'primary'}`} style={{ marginRight: 16, ...style }} onClick={download} disabled={size < 1}>下载</Button>
}

export const DownloadAll = (props) => {
  const { inspirationId, children, onChange } = props
  const onClick = (e) => {
    e && e.stopPropagation()

    renderDownloadModal({
      hiddenFolderLevel: true,
      onOk: async (type, keepStruct) => {
        await request.get(`/ins/inspiration/download-all-blog?inspirationId=${inspirationId}&type=${type}&keepStruct=${keepStruct}`)
        util.track('mn-image-download', {
          module1: '全部下载',
          module2: type === 1 ? '全部图片' : '首图',
        })
        DownloadCenter.start({ type: 1 })
        onChange && onChange()
      }
    })
  }
  return <div onClick={onClick}>{children || '下载全部款式'}</div>
}

export const ExportAll = (props) => {
  const { inspirationId, children, onChange } = props
  const [isLoading, setIsLoading] = useState(false)
  const onClick = async (e) => {
    e && e.stopPropagation()
    if (isLoading) return
    if (!teamHasAuth('meinian_export_all_blog')) {
      noPermissionPrompt({})
      return
    }
    try {
      setIsLoading(true)
      await request.get(`/ins/inspiration/export-all-blog?inspirationId=${inspirationId}`)
      DownloadCenter.start({ type: 0 })
      onChange && onChange()
    } catch (error) {
      message.warning(error.errorDesc)
      console.error(error)
    }
    setIsLoading(false)
  }
  return <div onClick={onClick}>{children || '导出全部款式'}</div>
}

export const Export = (props) => { // 批量导出款式
  const { fileName, onChange, green, style } = props
  const [size, setSize] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthLimit } = useVersionNumber()
  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])

  const onClick = async () => {
    if (isLoading) return
    if (!isAuthLimit('meinian_report_export_limit')) {
      versionNumber({
        title: '报表导出'
      })
      return
    }
    setIsLoading(true)
    const name = `${fileName}_导表时间${moment().format('YYYY-MM-DD_HH时mm分ss秒')}`
    await request.post('/zhikuan/mn/export/inspiration/export-task', {
      collectIdList: [...getBatchSelectedInfo()].map(m => m[1].collectId),
      fileName: name,
    })
    DownloadCenter.start({ type: 0 })
    onChange && onChange()
    setIsLoading(false)
    request.track({ code: 6400013, type: `批量导出-${[...getBatchSelected()]}` })
  }
  return <Tooltip title="导出选中灵感信息报表">
    <Button type={`${!green ? 'normal' : 'primary'}`} style={{ marginRight: 16, ...style }} onClick={onClick} disabled={size < 1}>导出</Button>
  </Tooltip>
}

export const ExportSample = (props) => { // 导出样衣
  const { fileName, onChange, green } = props
  const [size, setSize] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthLimit } = useVersionNumber()

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  const onClick = async () => {
    if (isLoading) return
    if (!isAuthLimit('meinian_report_export_limit')) {
      versionNumber({
        title: '报表导出'
      })
      return
    }
    setIsLoading(true)
    const name = `${fileName}_导表时间${moment().format('YYYY-MM-DD_HH时mm分ss秒')}`
    await request.post('/zhikuan/mn/export/sample/export-task', {
      sampleCodeList: [...getBatchSelectedInfo()].map(m => m[1].sampleCode),
      fileName: name,
    })
    DownloadCenter.start({ type: 0 })
    onChange && onChange()
    setIsLoading(false)
  }
  return <Tooltip title="导出选中样衣信息报表">
    {/* <Button ghost={!green} other={green} style={{ marginRight: 16, width: '80px', height: '28px', paddingTop: '5px', border: 0 }} onClick={onClick} disabled={size < 1}>导出</Button> */}
    <Button type={`${!green ? 'normal' : 'primary'}`} style={{ marginRight: 16 }} onClick={onClick} disabled={size < 1}>导出</Button>
  </Tooltip>
}

export const MoveSample = (props) => { // 移动样衣
  const { onChange, green } = props
  const [isLoading, setIsLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [moveIds, setMoveIds] = useState([])
  useEffect(() => {
    answer((ids, infos) => {
      const _ids = new Set([...ids])
      const _infos = [...infos].map(m => m[1])
      const moveAuth = _infos.every(i => i?.sampleClothingAuth?.includes('moveAndDeleteSample'))
      const _moveIds = _infos.filter(i => i?.sampleClothingAuth?.includes('moveAndDeleteSample')).map(i => i.id)
      if (_moveIds.length) {
        setMoveIds([..._moveIds])
      }
      if (_ids.size >= 1 && moveAuth) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    })
  }, [])

  const onMove = async (_curData, _id) => {
    const result = await request.post('/zhikuan/mn/sample/folder/move-sample-clothing', { toFolderId: _id, sampleIdList: moveIds })
    if (result) {
      message.success('移动成功')
      onChange?.()
    }
  }

  const onClick = async () => {
    if (isLoading) return
    moreFolderModalFun?.({
      title: '移动样衣至',
      type: 'sample',
      createFolderAuth: sampleHasAuth('createAndUpdateFolder'),
      option: {
        id: -1,
      },
      onOk: (curData, val) => onMove(curData, val)
    })
    setIsLoading(false)
  }
  return <Button type={`${!green ? 'normal' : 'primary'}`} style={{ marginRight: 16 }} onClick={onClick} disabled={disabled}>移动</Button>
}

export const MergeTags = (props) => {
  const { onChange } = props
  const [visible, setVisible] = useState(false)
  const [name, setName] = useState('')
  const [size, setSize] = useState(0)
  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  const merge = () => {
    setVisible(true)
  }
  return <>
    <Button type="normal" style={{ marginRight: 16 }} onClick={merge} disabled={size < 2}>合并</Button>
    {visible ? <Modal
      title={`合并${getBatchSelected().size}个标签`}
      visible={visible}
      onVisibleChange={_visible => setVisible(_visible)}
      closeAfterOk={false}
      onOk={async () => {
        if (!name) {
          message.info('请输入合并的标签名称')
          return
        }
        try {
          const res = await request.post('/zhikuan/img-tag/merge-tags', { tagIds: [...getBatchSelected()], tagName: name })
          message.success(<span>已成功合并为“<a href={`/meinian/home/tag/detail?tagId=${res}&tagName=${name}`}>{name}</a>”</span>)
          setVisible(false)
        } catch (error) {
          console.error(error)
        }
        onChange && onChange()
      }}
    >
      <div>
        <div style={{ marginBottom: 10 }}>请在下方输入合并后的标签名称：</div>
        <Input placeholder="标签名称" onChange={e => setName(e.target.value)} />
      </div>
    </Modal> : null}
  </>
}
export const DeleteTags = (props) => {
  const { onChange, } = props
  const [visible, setVisible] = useState(false)
  const [size, setSize] = useState(0)
  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  const onClick = () => {
    setVisible(true)
  }
  return <>
    <Button type="normal" style={{ marginRight: 16 }} onClick={onClick} disabled={size < 1}>删除</Button>
    {visible ? <Modal
      title="提示"
      visible={visible}
      onVisibleChange={_visible => setVisible(_visible)}
      onOk={async () => {
        try {
          await request.post('/zhikuan/img-tag/delete-tag', { tagIdList: [...getBatchSelected()] })
          message.success('已删除')
        } catch (err) {
          message.error(err)
        }
        onChange && onChange()
      }}
      okText="删除"
    >
      <span>确定要删除选中标签吗？删除标签后不能恢复</span>
    </Modal> : null}
  </>
}
export const MoveImages = (props) => {
  const { onChange, lajiInspirationId, green } = props
  const [blogs, setBlogs] = useState([])
  const [blogIds, setBlogIds] = useState([])
  useEffect(() => {
    answer((ids = new Set(), infos = new Map()) => { setBlogIds([...ids]); setBlogs([...infos].map(m => m[1])) })
  }, [])

  return <MoveImage
    blogs={blogs}
    blogIds={blogIds}
    onChange={onChange}
    ghost={!green}
    other={green}
    style={{ marginRight: 16 }}
    fromInspirationId={lajiInspirationId}
  />
}

export default {
  Collect,
  Delete,
  DeleteItem,
  Download,
  Export,
  ExportSample,
  MoveSample,
  MergeTags,
  DeleteTags,
  CreateSample,
  MoveImages,
}
